import { createNextTableContext } from '@core/table';

export const DnsQueuesTableContext = createNextTableContext();
